import type { ICustomerStore, ICustomerStoreInvestmentsGroupAccount } from './customerStore.model';
import { parse } from 'date-fns';
export const countryOfOrigin = (state: ICustomerStore) => state.customerProfile.country;

const _getCustServNumForCA = (locale: string) => {
  if (locale.includes('en_CA')) {
    return '18003877876';
  } else if (locale.includes('fr_CA')) {
    return '18002654804';
  }
  return '18003877876';
};

const _getCustServNum = (country: string | null, locale: string) => {
  if (country?.toUpperCase() === 'CA') {
    return _getCustServNumForCA(locale);
  }
  return '18002574725';
};

export const getCustServNumWODash = (state: ICustomerStore) => (locale: string) =>
  _getCustServNum(state.customerProfile.country, locale);

export const getCustServNumWDash = (state: ICustomerStore) => (locale: string) => {
  const customerNumber = _getCustServNum(state.customerProfile.country, locale) as string | null;
  return customerNumber && customerNumber.length > 0
    ? customerNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '($2) $3-$4')
    : '';
};

export const investmentsSortedByDate = (state: ICustomerStore) => {
  const accts: ICustomerStoreInvestmentsGroupAccount[] = [];
  if (state.investments.groups === undefined) {
    return accts;
  }
  state.investments.groups.forEach((group) => {
    group.accounts?.forEach((account: ICustomerStoreInvestmentsGroupAccount) => {
      accts.push(account);
    });
  });
  accts.sort((a, b) => {
    const aDate = parse(a.inceptionDate ?? '', 'MM/dd/yyyy', new Date());
    const bDate = parse(b.inceptionDate ?? '', 'MM/dd/yyyy', new Date());
    return bDate.valueOf() - aDate.valueOf();
  });
  return accts;
};
